// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select from '../layout/CustomSelect';
import Loader from '../dashboard/common/Loader';
import Notification from '../notification';
import { assignContractor, getApplicantsForBulkAssignToWorkOrders } from '../../storage/actions/workOrdersActions';
import { toggleModal } from '../../storage/actions/modalsActions';
import { dashboard as dashboardSelectStyle, dashboardSelectClassNames } from '../../utils/customSelectStyle';
import prepareFilters from '../../utils/prepareFilters';
import { getStatus } from '../../utils/api/get/getWorkOrders';

const BulkWorkOrderAssignContractorModal = ({
  modalState,
  selectedWorkOrders,
  // eslint-disable-next-line no-shadow
  toggleModal, assignContractor, getApplicantsForBulkAssignToWorkOrders,
  filters, search, activeTab,
}) => {
  const [selectedContractor, setSelectedContractor] = useState();
  const [contractors, setContractors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [requestData, setRequestData] = useState({});

  const initRequestData = () => {
    const newRequestData = modalState?.type?.mode === 'useFilters'
      ? {
        ...search,
        filters: prepareFilters(filters),
      }
      : { workOrdersId: selectedWorkOrders };
    setRequestData({ ...newRequestData, ...getStatus(activeTab) });
    return ({ ...newRequestData, ...getStatus(activeTab) });
  };

  const fetchData = async () => {
    setIsLoading(true);
    const contractorsList = await getApplicantsForBulkAssignToWorkOrders(initRequestData());
    const newContractorsList = contractorsList || [];
    setContractors(newContractorsList.map((contractor) => (
      {
        value: contractor,
        label: `${contractor.name} - ${contractor.unique_id} - ${contractor.address || '!?ADDRESS!?'}, ${contractor.city?.label || '!?CITY!?'}, ${contractor.state?.label || '!?STATE!?'} ${contractor.zipcode || '!?ZIPCODE!?'}`,
      }
    )));
    setIsLoading(false);
  };

  useEffect(() => {
    if (!modalState?.isOpen) {
      return undefined;
    }

    fetchData();

    return () => {
      setSelectedContractor(undefined);
      setContractors([]);
      setIsLoading(true);
    };
  }, [modalState?.isOpen]);

  const closeModal = () => {
    toggleModal(false, 'bulkWorkOrderAssignContractorModal', false, '');
  };

  const handlerSubmit = (event) => {
    event.preventDefault();
    if (!selectedContractor?.value?.userId) {
      Notification('warning', { message: 'Please select contractor!' });
    } else {
      assignContractor(requestData, selectedContractor.value.userId);
    }
  };

  const filterOption = (item, filter = '') => {
    const newRegExp = new RegExp(filter, 'i');
    return (newRegExp.test(item.value.name) || newRegExp.test(item.value.unique_id));
  };

  if (!modalState?.isOpen) {
    return null;
  }

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="modal_container"
        style={{ minHeight: 'fit-content' }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="assign-contractor-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title" id="assign-contractor-title">
            Assign Contractor
          </div>
          <button
            type="button"
            className="close_btn icon_close"
            aria-label="close"
            onClick={closeModal}
          />
        </div>
        <div className="modal_body">
          <div className="info_block">
            <div className="block_sub">
              If you do not see a contractor listed, please be sure they have applied to the work order(s) you have selected.
            </div>
          </div>
          <div className="field_row">
            {isLoading ? (
              <div className="flex-box flex-center">
                <Loader color="black" />
              </div>
            ) : (
              <div className="field_block dashboard-select-wrap">
                <Select
                  isClearable
                  isSearchable
                  filterOption={filterOption}
                  options={contractors}
                  value={selectedContractor}
                  styles={dashboardSelectStyle}
                  classNames={dashboardSelectClassNames}
                  onChange={setSelectedContractor}
                  noOptionsMessage={() => 'If you do not see a contractor listed, please be sure they have applied to the work order(s) you have selected.'}
                  placeholder="Select Contractor!"
                />
              </div>
            )}
          </div>
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="standard_btn dark_btn"
            aria-label="assign"
            onClick={handlerSubmit}
          >
            Assign
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  assignContractor,
  getApplicantsForBulkAssignToWorkOrders,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.bulkWorkOrderAssignContractorModal,
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
  filters: state.workOrder?.filters,
  search: state.workOrder?.searchData,
  activeTab: state.applicationState.activeTab,
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkWorkOrderAssignContractorModal);
